module.exports = __webpack_public_path__ + "static/media/logo.f0703058.jpg";